var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticStyle:{"padding":"20px"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('keep-alive',{attrs:{"include":"projectReport"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }